import React, { Component } from 'react';
import { toast } from 'react-toastify';
import NslMailAPI from '../NslMailAPI.js';

class VerifyEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            verificationResult: null,
            error: null
        };
    }

    async componentDidMount() {
        const code = this.props.match.params.code;
        
        if (!code) {
            this.setState({
                isLoading: false,
                error: 'No verification code provided'
            });
            return;
        }

        try {
            const API = new NslMailAPI();
            const result = await API.verifyEmail(code);
            this.setState({
                isLoading: false,
                verificationResult: result.message
            });
            toast.success(result.message);
        } catch (error) {
            console.error('Email verification error:', error);
            this.setState({
                isLoading: false,
                error: error.message || 'Error verifying email address'
            });
            toast.error(error.message || 'Error verifying email address');
        }
    }

    render() {
        const { isLoading, verificationResult, error } = this.state;

        if (isLoading) {
            return (
                <div className="verify-email">
                    <h2>Verifying Your Email Address</h2>
                    <p>Please wait while we verify your email address...</p>
                </div>
            );
        }

        if (error) {
            return (
                <div className="verify-email">
                    <h2>Email Verification Failed</h2>
                    <p style={{color: '#d32f2f'}}>{error}</p>
                    <div className="verify-actions">
                        <p>
                            <a href="/">Return to Home</a> | 
                            <a href="/contact"> Contact Support</a>
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className="verify-email">
                <h2>Email Verification Successful</h2>
                <p style={{color: '#2e7d32'}}>{verificationResult}</p>
                <div className="verify-actions">
                    <p>
                        <a href="/" className="link-button">Continue to NslMail</a>
                    </p>
                </div>
            </div>
        );
    }
}

export default VerifyEmail;